import React, {Component} from 'react';
import {Col, Form, Row, DatePicker, Button, Spin, Pagination, Modal} from "antd";
import {api, app, config} from "../../app";
import MineTrainDetails from "../skillTrain/MineTrainDetails";

class UserReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: [],//用户信息
            userData_loading: false,
            mode: ['month','month'],
            value: [],
            start_time: '',
            end_time: '',
            img_loading: false,
            coding: '',
            report_url: '',
            total: 0,
            page: 1,
            history_loading: false,
            historyList: [],
            history_title: '',
            history_url: '',
            history_modal: false
        };
    }

    async componentDidMount() {
        this._isMounted = true
        await this.userData();
        await this.hList();
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 历史列表
     */
    hList = async (page = 1) => {
        await this.setData({ page, history_loading: true })
        let params = {
                account: app.getData('account'),
                indexno: app.getData('indexno'),
                page
            }
        let { flag, data, msg, total } = await app.post(api.UserReportHistoryList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ historyList: data, history_loading: false, total: Number(total || 0) })
    }

    /**
     * 生成报表
     */
    getUserReport = async () => {
        let {start_time,end_time,page} = this.state;
        if(!start_time || !end_time){
            app.alert("请选择志愿服务时间段")
            return false
        }
        await this.setData({ userData_loading: true, report_url:'' })
        const params = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            start_time,
            end_time,
        }
        let { flag, data, msg } = await app.post(api.UserReport,params)
        let state = { userData_loading: false }
        if (flag === 1) {
            state.report_url = config.imgUrl + data.report_url;
            state.coding = data.coding;
            await this.hList(page);
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 用户信息
     **/
    userData = async () => {
        const params = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
        }
        let { flag, data, msg } = await app.post(api.UserData,params)
        if (flag === 1) {
            await this.setData({userInfo:data})
        } else {
            app.alert(msg, "error")
        }
    }

    //选择日期
    handlePanelChange = (value, mode) => {
        this.setState({
            start_time:value[0].format('YYYY-MM'),
            end_time:value[1].format('YYYY-MM'),
            value,
            mode: [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]],
        });

    };

    //下载图片
    downLoad = (coding) =>{
        let that = this;
        that.setData({ img_loading: true });
        let xhr = new XMLHttpRequest()
        xhr.open('POST', config.serverUrl + '/PrintReport/imgBase64', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("indexno", app.getData('indexno'));
        fd.append("account", app.getData('account'));
        fd.append("token", app.getData('token'));
        fd.append("coding", coding);
        xhr.send(fd);
        xhr.onload = function () {
            let blob = this.response;
            that.downloadFile(blob, coding+'.png');
        }
        xhr.onloadend = e => {
            that.setData({ img_loading: false });
        };
    }

    downloadFile(data,fileName){
        let blob = new Blob([data], { type: 'image/png' });
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);
    }

    /**
     * 打开详情
     */
    historyOpeningModal = async (obj) => {
        console.log(obj)
        await this.setData({ history_url:obj.report_url,history_title:obj.coding,history_modal: true })
    }

    /**
     * 关闭详情
     */
    historyCloseModal = async (obj) => {
        await this.setData({ history_modal: false, history_url: '' })
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let {page,total,historyList,history_loading,history_modal,history_title,history_url,userInfo,value,mode,img_loading,report_url,userData_loading,coding}= this.state;
        return (
            <div className="user-report">
                <div className="user-report-title">打印服务时长</div>
                <div className="mp-content-report ant-row">
                    <div className="left-content">
                        <div style={{width:'700px',marginBottom:'20px'}}>
                            <img style={{width:'100%'}} src={config.imgUrl + '/Uploads/FWSC-GD.png'}/>
                        </div>
                        <div>
                            <img src={config.imgUrl + app.urlEncode(userInfo.portrait)} className="avatar" />
                        </div>
                        <div className="user-info">
                            <div>姓名：{userInfo.vname}</div>
                            <div>存心编号：{userInfo.bsrno}</div>
                            <div>身份证号码：{userInfo.idno}</div>
                        </div>
                        <div className="choose-time">
                            <div style={{color:'red',marginBottom:'10px'}}>24小时内只能生成一次时长报告，每个时长报告的时间范围不超过12个月</div>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col style={{fontSize:'16px',fontWeight:'bold'}}>选择志愿服务时间段：</Col>
                                <Col>
                                    <DatePicker.RangePicker
                                        placeholder={['开始月份', '结束月份']}
                                        format="YYYY-MM"
                                        value={value}
                                        mode={mode}
                                        onChange={this.handleChange}
                                        onPanelChange={this.handlePanelChange}
                                    />
                                </Col>
                                <Col>
                                    <Button type="primary" loading={userData_loading} onClick={() => this.getUserReport()}>生成时长证明</Button>
                                </Col>
                            </Row>
                        </div>
                        {report_url?(
                            <div className="cert-img">
                                <div className="download-button">
                                    <Button type="primary" icon="download" loading={img_loading} onClick={() => this.downLoad(coding)}>下载证明</Button>
                                </div>
                                <img src={report_url} className="cimg" />
                                <div className="download-button">
                                    <Button type="primary" icon="download" loading={img_loading} onClick={() => this.downLoad(coding)}>下载证明</Button>
                                </div>
                            </div>
                        ):null}
                    </div>
                    <div className="right-content">
                        <div className="right-content-title">历史打印时长</div>
                        <div className="history-list">
                            {historyList.length == 0 && page ==1?(
                                <div>暂无数据</div>
                            ):null}
                            {history_loading?(<div className="mall-loading"><Spin size="large"/></div>):
                                historyList.map((item,index) => {
                                    return (
                                        <div key={index} className="list-content">
                                            <div className="content-coding">
                                                <div>{item.create_time || '-'}</div>
                                                <div style={{color:'#8ec0dd'}}>{item.coding || '-'}</div>
                                            </div>
                                            <div className="content-time">
                                                <div>{item.start_time || '-'}</div>
                                                <div>{item.end_time || '-'}</div>
                                            </div>
                                            <div className="list-botton">
                                                <Button type="primary" size="small" onClick={()=> this.historyOpeningModal(item)}>查看详情</Button>
                                                <Button style={{marginTop:'3px'}} type="primary" size="small" loading={img_loading} onClick={() => this.downLoad(item.coding)}>下载证明</Button>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div style={{width:'100%',textAlign:'right',marginTop:'15px'}}>
                            <Pagination
                                size="small"
                                current={page}
                                total={total}
                                pageSize={20}
                                showTotal={(t) => `总数量：${t}`}
                                onChange={this.hList}
                            />
                        </div>
                    </div>
                </div>
                <Modal
                    visible={history_modal}
                    title={history_title}
                    footer={null}
                    width="700px"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.historyCloseModal}
                    bodyStyle={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}
                    style={{ paddingBottom: 0, top: 70 }}
                >
                    <Button style={{marginTop:'3px'}} type="primary" size="small" loading={img_loading} onClick={() => this.downLoad(history_title)}>下载证明</Button>
                    <img style={{width:'100%'}} src={config.imgUrl + history_url} />
                </Modal>
            </div>
        );
    }
}
export default UserReport



// WEBPACK FOOTER //
// ./src/routes/playerInfo/UserReport.jsx